module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-upload-file"
    }
  }, [_c('dropzone', {
    attrs: {
      "id": "vueDropzone",
      "url": _vm.url,
      "useFontAwesome": true,
      "acceptedFileTypes": "application/pdf,.doc,.docx,.xlsx,.xls",
      "showRemoveLink": false
    },
    on: {
      "vdropzone-success": _vm.showSuccess
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "xxx"
    }
  })]), _vm._v("\n  " + _vm._s(_vm.url) + "\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69de36b6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoUploadFile.vue
// module id = 3831
// module chunks = 1